import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M14.848 6H6V4c0-.551.548-1 1.222-1H10.5c.276 0 .5-.224.5-.5s-.224-.5-.5-.5H7.222C5.995 2 5 2.895 5 4v2.014c-1.112.074-2 .933-2 1.984v8.001c0 1.099.969 1.999 2.152 1.999h9.695c1.184 0 2.152-.899 2.152-1.999V7.998c0-1.099-.969-1.999-2.152-1.999zM16 16c0 .541-.528.999-1.152.999H5.153c-.625 0-1.152-.457-1.152-.999V7.999c0-.541.528-.999 1.152-.999h9.695c.625 0 1.152.457 1.152.999V16zm-5-5v2c0 .55-.45 1-1 1s-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1z',
  ],
  height: 20,
  width: 20,
});
